module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav-bar', {
    attrs: {
      "title": "No Content"
    }
  }), _vm._v(" "), _c('scroller', {
    attrs: {
      "on-infinite": _vm.infinite,
      "min-content-height": 44
    }
  }, [_c('div', {
    staticStyle: {
      "height": "44px"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-229e6ceb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/components/NoContent.vue
// module id = 47
// module chunks = 0